const CoachProgramNeedsBase = () => import("./pages/CoachProgramNeedsBase");

export default {
    path: "/recruits/program-needs/",
    redirect: '/recruits/program-needs/create',
    component: CoachProgramNeedsBase,
    children: [
        {
            name: 'programneeds.create',
            path: "create",
            component: () => import(
                /* webpackChunkName: "clubimport.columns" */ "./components/CoachCreateNeeds"
                )
        },
        {
            name: 'programneeds.edit',
            path: "edit",
            component: () => import(
                /* webpackChunkName: "clubimport.columns" */ "./components/CoachEditNeeds"
                ),
        },
    ],
}
